import { render } from "./Stap3.vue?vue&type=template&id=dd7b0650"
import script from "./Stap3.vue?vue&type=script&lang=js"
export * from "./Stap3.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__